import { fromJS } from 'immutable';

import FundingSearchLegacy from 'models/FundingSearchLegacyModel';
import FundingSearch from 'models/FundingSearchModel';

import { generateReducer } from '../utils/HttpReducerHelper';
import { combineReducerArray } from '../utils/helpers';

import contactDetailsReducer from './contactDetails/reducer';
import dueActivitiesCountReducer from './dueActivitiesCount/reducer';
import fundingSearchMatchReducer from './match/reducer';
import fundingSearchOffersReducer from './offers/reducer';
import privacyToggleReducer from './privacyToggle/reducer';
import offersHistoryReducer from './offersHistory/reducer';
import searchFollowersReducer from './searchFollowers/reducer';
import searchManagerReducer from './searchManager/reducer';

import {
  fundingSearchActive,
  fundingSearchCompleted,
  fundingSearchShared,
  fundingSearch,
  fundingSearchCompleteApplication,
  fundingSearchMatches,
  cancelFundingSearch,
  cancelFundingSearchMatch,
  deleteBusinessProfile,
  OPEN_CANCEL_FUNDING_SEARCH_MODAL,
  CLOSE_CANCEL_FUNDING_SEARCH_MODAL,
  OPEN_DELETE_BUSINESS_PROFILE_MODAL,
  CLOSE_DELETE_BUSINESS_PROFILE_MODAL,
  OPEN_REQUEST_FUNDING_SEARCH_HELP_MODAL,
  CLOSE_REQUEST_FUNDING_SEARCH_HELP_MODAL,
  SET_FUNDING_SEARCH_PROFILE_COMPLETION,
  SET_TRADE_HISTORY_ACCOUNTING_SOLUTION,
  OPEN_DELETE_DIRECTOR_CONFIRMATION_MODAL,
  CLOSE_DELETE_DIRECTOR_CONFIRMATION_MODAL,
} from './types';

export * from './actions';

const initialState = fromJS({
  byId: {},
  active: {
    ids: [],
    network: { loading: false, error: false },
  },
  completed: {
    ids: [],
    network: { loading: false, error: false },
  },
  shared: {
    ids: [],
    network: { loading: false, error: false },
  },
  fundingSearchPage: {
    network: { loading: false, error: false },
  },
  fundingSearchCompleteApplication: {
    network: { loading: false, error: false },
  },
  fundingSearchManager: {
    // [fundingSearch.id]: {
    //     update: { network: { loading: false, error: false } },
    // },
  },
  fundingSearchFollowers: {
    // [fundingSearch.id]: {
    //     data: [],
    //     network: { loading: false, error: false }
    //     update: { network: { loading: false, error: false } },
    // },
  },
  fundingSearchContactDetails: {
    // [fundingSearch.id]: {
    //     data: [],
    //     network: { loading: false, error: false }
    // },
  },
  fundingSearchDueActivitiesCount: {
    // [fundingSearch.id]: 0,
  },
  cancelFundingSearch: {
    modalOpen: false,
    fundingSearch: false,
  },
  deleteDirectorConfirmation: {
    modalOpen: false,
    deletePromise: false,
  },
  cancelFundingSearchMatch: {
    modalOpen: false,
    network: { loading: false, error: false },
  },
  fundingSearchMatchOffers: {
    byId: {},
    fundingSearchId: false,
    groupByFundingMatchId: {},
    ids: [],
    network: { loading: false, error: false },
  },
  fundingSearchMatchOffer: {
    ids: {},
    network: { loading: false, error: false },
    match: {
      network: { loading: false, error: false },
    },
  },
  offersHistory: {
    byId: {},
    groupByFundingMatchId: {},
    ids: [],
    network: {
      loading: false,
      error: false,
    },
  },
  deleteBusinessProfile: {
    modalOpen: false,
    fundingSearch: false,
  },
  privateToggleFundingSearchModal: {
    modalOpen: false,
    fundingSearch: false,
  },
  requestFundingSearchHelp: {
    modalOpen: false,
    fundingSearch: false,
  },
  matchIgnoredStatuses: {
    // 'matchId': [...statuses]
  },
  fetchingOfferMatchIds: [],
  notifications: [],
  accountingSolution: '',
});

const deleteSearchById = (state, action) => {
  const getIndexFor = (type) => [
    type,
    'ids',
    state.getIn([type, 'ids']).indexOf(action.fundingSearchId),
  ];

  return state.withMutations((currentState) =>
    currentState
      .deleteIn(['byId', action.fundingSearchId])
      .deleteIn(getIndexFor('active'))
      .deleteIn(getIndexFor('completed'))
      .deleteIn(getIndexFor('shared')),
  );
};

const fundingSearchActiveReducer = generateReducer('active', FundingSearchLegacy.deserialize);
const fundingSearchCompletedReducer = generateReducer('completed', FundingSearchLegacy.deserialize);
const fundingSearchSharedReducer = generateReducer('shared', FundingSearchLegacy.deserialize);

const fundingSearchReducer = {
  [fundingSearchActive.request]: fundingSearchActiveReducer.request,
  [fundingSearchActive.success]: fundingSearchActiveReducer.success,
  [fundingSearchActive.failure]: fundingSearchActiveReducer.failure,

  [fundingSearchCompleted.request]: fundingSearchCompletedReducer.request,
  [fundingSearchCompleted.success]: fundingSearchCompletedReducer.success,
  [fundingSearchCompleted.failure]: fundingSearchCompletedReducer.failure,

  [fundingSearchShared.request]: fundingSearchSharedReducer.request,
  [fundingSearchShared.success]: fundingSearchSharedReducer.success,
  [fundingSearchShared.failure]: fundingSearchSharedReducer.failure,

  [fundingSearch.request]: (state) =>
    state.setIn(['fundingSearchPage', 'network', 'loading'], true),
  [fundingSearch.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingSearchPage', 'network', 'loading'], false)
        .setIn(['fundingSearchPage', 'network', 'error'], false)
        .setIn(['byId', action.fundingSearchId], FundingSearch.deserialize(action.response)),
    ),
  [fundingSearch.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingSearchPage', 'network', 'loading'], false)
        .setIn(['fundingSearchPage', 'network', 'error'], action.error),
    ),

  [fundingSearchCompleteApplication.request]: (state) =>
    state.setIn(['fundingSearchCompleteApplication', 'network', 'loading'], true),
  [fundingSearchCompleteApplication.success]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingSearchCompleteApplication', 'network', 'loading'], false)
        .setIn(['fundingSearchCompleteApplication', 'network', 'error'], false),
    ),
  [fundingSearchCompleteApplication.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingSearchCompleteApplication', 'network', 'loading'], false)
        .setIn(['fundingSearchCompleteApplication', 'network', 'error'], action.error),
    ),

  [fundingSearchMatches.request]: (state) =>
    state.setIn(['fundingSearchPage', 'network', 'loading'], true),
  [fundingSearchMatches.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingSearchPage', 'network', 'loading'], false)
        .setIn(['fundingSearchPage', 'network', 'error'], false)
        .setIn(['byId', action.fundingSearchId, 'matches'], action.response),
    ),
  [fundingSearchMatches.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingSearchPage', 'network', 'loading'], false)
        .setIn(['fundingSearchPage', 'network', 'error'], action.error),
    ),
  [cancelFundingSearch.success]: deleteSearchById,

  [deleteBusinessProfile.success]: deleteSearchById,

  [OPEN_CANCEL_FUNDING_SEARCH_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['cancelFundingSearch', 'modalOpen'], true)
        .setIn(['cancelFundingSearch', 'fundingSearch'], action.fundingSearch),
    ),
  [OPEN_DELETE_DIRECTOR_CONFIRMATION_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['deleteDirectorConfirmation', 'modalOpen'], true)
        .setIn(['deleteDirectorConfirmation', 'deletePromise'], action.promise),
    ),
  [CLOSE_CANCEL_FUNDING_SEARCH_MODAL]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['cancelFundingSearch', 'modalOpen'], false)
        .setIn(['cancelFundingSearch', 'fundingSearch'], false),
    ),
  [CLOSE_DELETE_DIRECTOR_CONFIRMATION_MODAL]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['deleteDirectorConfirmation', 'modalOpen'], false)
        .setIn(['deleteDirectorConfirmation', 'deletePromise'], false),
    ),

  [OPEN_DELETE_BUSINESS_PROFILE_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['deleteBusinessProfile', 'modalOpen'], true)
        .setIn(['deleteBusinessProfile', 'fundingSearch'], action.fundingSearch),
    ),

  [CLOSE_DELETE_BUSINESS_PROFILE_MODAL]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['deleteBusinessProfile', 'modalOpen'], false)
        .setIn(['deleteBusinessProfile', 'fundingSearch'], false),
    ),

  [OPEN_REQUEST_FUNDING_SEARCH_HELP_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['requestFundingSearchHelp', 'modalOpen'], true)
        .setIn(['requestFundingSearchHelp', 'fundingSearch'], action.fundingSearch),
    ),
  [CLOSE_REQUEST_FUNDING_SEARCH_HELP_MODAL]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['requestFundingSearchHelp', 'modalOpen'], false)
        .setIn(['requestFundingSearchHelp', 'fundingSearch'], false),
    ),

  [SET_FUNDING_SEARCH_PROFILE_COMPLETION]: (state, action) =>
    state.setIn(['byId', action.fundingSearchId, 'profileCompletion'], action.completion),

  [SET_TRADE_HISTORY_ACCOUNTING_SOLUTION]: (state, action) =>
    state
      .set('accountingSolution', action.accountingSolution)
      .setIn(
        ['byId', action.fundingSearchId, 'client', 'integratedFrom'],
        action.accountingSolution,
      ),
};

export default combineReducerArray(initialState, [
  cancelFundingSearchMatch,
  contactDetailsReducer,
  dueActivitiesCountReducer,
  fundingSearchMatchReducer,
  fundingSearchOffersReducer,
  fundingSearchReducer,
  offersHistoryReducer,
  privacyToggleReducer,
  searchFollowersReducer,
  searchManagerReducer,
]);
